import { render, staticRenderFns } from "./dictSonForm.vue?vue&type=template&id=5302604d"
import script from "./dictSonForm.vue?vue&type=script&lang=js"
export * from "./dictSonForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports